import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="hero" className="main-block">
      <div className="overlay"></div>
      <div className="container py-5">
        <div className="row text-center g-4">
          <div className="col-sm-12">
            <div className="pre-description my-3">
              ProfitPalm Agency - full-cycle marketing agency
            </div>
            <h1 className="fw-bold">Launching and promoting your Amazon business</h1>
            <div className="description my-4">
              Comprehensive solutions to increase the profitability of your Amazon business
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
